// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"d7db5d9b","235":"cda81f79","289":"4a8db3e7","471":"b6629763","730":"7fe70ccd"}[chunkId] + ".chunk.js";
};